import { Link, Outlet, useLocation, useNavigation, useRouteLoaderData } from 'react-router';
import RouteProgress from '../components/RouteProgress';
import { NAV } from '../lib/onboarding/roles';
import type { RootLoaderData } from '../lib/types';

/**
 * Everything inside the studio hangs off this. The navigation follows the role,
 * so a company never sees "Find Projects" and a student never sees "Find
 * Talent" — section 14 of the spec, and the reason the layout reads loader data
 * rather than rendering one fixed bar.
 */
export default function RootLayout() {
  const navigation = useNavigation();
  const location = useLocation();
  const { profile } = useRouteLoaderData('root') as RootLoaderData;

  const items = profile.userType ? NAV[profile.userType] : [];

  return (
    <>
      {navigation.state === 'loading' ? <RouteProgress /> : null}
      <main className="shell">
        <div className="card card-lg">
          <nav className="nav" aria-label="Studio">
            {items.map(item => (
              <Link key={item.to} to={item.to} className={item.to === location.pathname ? 'on' : ''}>
                {item.label}
              </Link>
            ))}
          </nav>
          <Outlet />
        </div>
      </main>
    </>
  );
}
